import { Button } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { getImageSrc } from '../../../../../helpers/getImageSrc'
import { createServiceRequestStore } from '../stores/NewCreateServiceRequestStore'

interface NotFoundSearchResultButtonsProps {
  onBack: () => void
}

const NotFoundSearchResultButtons: FC<NotFoundSearchResultButtonsProps> = ({
  onBack,
}) => {
  const { setIsCreateDrawerOpen, setIsResultsDrawerOpen } =
    createServiceRequestStore

  const onCreateBtnClick = () => {
    setIsResultsDrawerOpen(false)
    setIsCreateDrawerOpen(true)
  }

  return (
    <>
      <Button variant='contained' onClick={onBack}>
        <img
          alt={'Назад'}
          src={getImageSrc('arrow-left')}
          style={{ marginRight: '4px' }}
        />
        Вернуться к поиску
      </Button>
      <Button variant='outlined' onClick={onCreateBtnClick}>
        Создать заявку без указания ID
      </Button>
    </>
  )
}

export default observer(NotFoundSearchResultButtons)
